import React, { Component } from "react";
import styled from "styled-components";
import { Button, Input, P, Small, theme } from "@upsolve/ui";
import { ERROR_CODES } from "@upsolve/shared";

import InputRow from "../Inputs/InputRow.div";
import submitNewsletterSignup from "./submitNewsletterSignup";
import validateEmailAddress from "../utils/validateEmailAddress";
import withViewportWatch from "../analytics/withViewportWatch";
import trackComponentImpression from "../analytics/trackComponentImpression";
import trackComponentAction from "../analytics/trackComponentAction";
import Portal from "../overlays/Portal";
import NewsletterPopupModal from "../overlays/NewsletterPopupModal";

const trackingProps = {
  componentName: "CTANewsletterSignup",
  componentVersion: 1,
};

/**
 * CTANewsletterSignup
 * - v0: Minimal styling on inline email capture.
 * - v1: Higher contrast styling > pushes to newsletter overlay
 *
 * @component
 * @version 1
 */
class CTANewsletterSignup extends Component {
  state = {
    impressionTracked: false,
    openNewsletterModal: false,
  };

  openOverlay() {
    CTANewsletterSignup;
    this.setState({ openNewsletterModal: true });
    trackComponentAction({
      ...trackingProps,
      actionId: "ctaNewsletterSignup.openNewsletterOverlay",
      actionMethod: "click",
    });
  }

  render() {
    const { impressionTracked, openNewsletterModal } = this.state;

    if (this.props.isInViewport && !impressionTracked) {
      this.props.stopWatcher();
      trackComponentImpression(trackingProps).then(() => this.setState({ impressionTracked: true }));
    }

    return (
      <div>
        <CTANewsletterSignupWrapper>
          <div className="newsletter-label">
            <P>
              <b>Receive our definitive guide on bankruptcy in {new Date().getFullYear()}. Everything you need to know during COVID-19.</b>
            </P>
          </div>
          <div className="newsletter-input-row">
            <Button disabled={this.state.submitted} onClick={() => this.openOverlay()} width="100%">
              Get Access
            </Button>
          </div>
        </CTANewsletterSignupWrapper>
        {openNewsletterModal && (
          <Portal>
            <NewsletterPopupModal onClose={() => this.setState({ openNewsletterModal: false })} />
          </Portal>
        )}
      </div>
    );
  }
}

const CTANewsletterSignupWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1em;
  background: ${(props) => props.theme.colors.white[700]};
  border: 1px solid ${(props) => props.theme.colors.white[500]};
  border-radius: 4px;
  .newsletter-input-row {
    margin-left: 1em;
    width: 35%;
  }
  p {
    font-size: 16px;
    padding: 0;
    margin: 0;
  }
  @media (max-width: 45em) {
    flex-direction: column;
    text-align: center;
    padding: 1em;
    p {
      margin: 0 0 1em;
    }
    .newsletter-input-row {
      width: 100%;
      margin: 0;
    }
  }
`;

export default withViewportWatch(CTANewsletterSignup);
